import "core-js/modules/es.object.keys.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-06a6ea93"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "CommentItem"
};
var _hoisted_2 = {
  key: 0,
  class: "comments"
};
var _hoisted_3 = {
  class: "img"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "title"
};
var _hoisted_6 = {
  class: "all-title"
};
var _hoisted_7 = {
  class: "title-name"
};
var _hoisted_8 = {
  class: "title-comment"
};
var _hoisted_9 = {
  key: 0,
  class: "back-title"
};
var _hoisted_10 = {
  class: "title-backtname"
};
var _hoisted_11 = {
  class: "time"
};
var _hoisted_12 = {
  class: "like"
};

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont"
  }, "", -1
  /* HOISTED */
  );
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [Object.keys(_ctx.commentItem).length !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    src: _ctx.commentItem.user.avatarUrl
  }, null, 8
  /* PROPS */
  , _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.commentItem.user.nickname) + "：", 1
  /* TEXT */
  ), _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.commentItem.content), 1
  /* TEXT */
  )]), _ctx.commentItem.beReplied.length ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.commentItem.beReplied[0].user.nickname) + "：", 1
  /* TEXT */
  ), _createTextVNode(" " + _toDisplayString(_ctx.commentItem.beReplied[0].content), 1
  /* TEXT */
  )])) : _createCommentVNode("v-if", true)]), _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$filters.formatTime(_ctx.commentItem.time)), 1
  /* TEXT */
  )]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("span", null, _toDisplayString(_ctx.commentItem.likedCount), 1
  /* TEXT */
  )])])) : _createCommentVNode("v-if", true)]);
}